export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const SYMBOLS = ["BTC-USDT", "ETH-USDT", "SOL-USDT", "OKB-USDT"];

export const formatUsd = (value) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(value || 0);

export const formatNumber = (value, digits = 4) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: digits }).format(value || 0);